module.exports = __webpack_public_path__ + "static/media/skila-bg_img-02-2-pod_600px_width-0_1-@2x.a56fa16f.png";